import styled from 'styled-components';

export default function CustomInput(props) {
  const { value, setValue, placeholder, width, disabled, disabled2, textAlign, onlyNumber, onFocus, flexShrink = false } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    if (onlyNumber) {
      setValue(e.target.value.replace(/[^0-9]/g, ''));
    } else {
      setValue(e.target.value);
    }
  }

  function handleFocus(e) {
    if (onFocus) onFocus(e);
  }

  function handleBlur(e) {
  }

  return (
    <Input $disabled={disabled}
      $disabled2={disabled2}
      type='text'
      disabled={disabled || disabled2}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      $flexShrink={flexShrink}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width ? `${props.width}px` : undefined};
  flex: ${props => props.width ? undefined : 1};
  min-width: ${props => props.$flexShrink ? '0' : undefined};
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid ${props => props.$disabled ? props.theme.background : props.theme.line};
	border-radius: 5px;
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

  text-align: ${props => props.textAlign};
  pointer-events: ${props => props.$disabled ? 'none' : 'auto'};

  background-color: ${props => props.$disabled2 ? props.theme.buttonFill : props.theme.subBackground};
  border-color: ${props => props.$disabled2 ? props.theme.buttonFill : props.theme.line};

  transition: all 0.3s ease-in-out;
`;